import { getChartLabels, getChartData } from 'backend/DBFunctions.jsw';
import wixData from 'wix-data';
import wixWindow from 'wix-window';

const barChartBackgroundColors = [
    '#00495c', '#095c71',
    '#136e86', '#1c819b',
    '#479fb6', '#71bed1',
    '#9cdcec', '#bde8f2',
    '#daf2f8', '#e9f7fb'
]
const barChartBordersColor = '#333333'
let barChartLabels = [];
let isFirstTimeLoading = true;
let menuCurrentIndex = 1

$w.onReady(function () {
    initPageEvents();
});

function initPageEvents() {

    menuMobile()
    shareBtn()
    setMenu()
    dropdownRevenue()
    monthsDropDownEvents()
    setTimeout(function () {
        $w("#sectionFold2").expand()
        $w("#sectionFold3").expand()
        $w("#sectionFold4").expand()
        $w("#sectionFold5").expand()
        $w("#sectionFold6").expand()
        $w("#sectionFold7").expand()
        // $w("#sectionFold8").expand()
        $w("#sectionFold9").expand()
        $w("#sectionFooter").expand()
    }, 500);
    $w("#barChart").onMessage(async event => {
        if (event.data.type === 'ready') {
            barChartLabels = await getChartLabels();
            setChartLabels(barChartLabels);
            sendDataToChart();
        }
    })
}

function setChartLabels(labels) {
    labels.forEach((label, index) => {
        $w(`#barChartLabel${index+1}`).html = `<p class="font_8" style="text-transform:uppercase">${label}</p>`;
    })
}
async function sendDataToChart() {

    const month = $w("#buttonOpenDropdownGraph").label;
    const chartData = await getChartData(month, barChartLabels);
    $w('#barChart').postMessage({
        values: chartData,
        labels: barChartLabels,
        backgroundColor: barChartBackgroundColors,
        borderColor: barChartBordersColor,
        isFirstTimeLoading: isFirstTimeLoading
    })
    isFirstTimeLoading = false;
}

export function menuMobile() {

    $w("#boxCloseMenu").onClick((event) => {
        $w("#menuContainer").close()
    });
}

export function setMenu() {
    // iconShareReg1
    // iconShareHover1

    let text1 = $w("#textMenu1").text
    let text2 = $w("#textMenu2").text
    let text3 = $w("#textMenu3").text
    let text4 = $w("#textMenu4").text
    let text5 = $w("#textMenu5").text
    let text6 = $w("#textMenu6").text
    let text7 = $w("#textMenu7").text
    let text8 = $w("#textMenu8").text

    // view port

    $w("#anchorFold1").onViewportEnter((event) => {
        menuCurrentIndex = 1
        setMenuIndexOnclick()
    });

    $w("#anchorFold2").onViewportEnter((event) => {
        menuCurrentIndex = 2
        setMenuIndexOnclick()
    });

    $w("#anchorFold3").onViewportEnter((event) => {
        menuCurrentIndex = 3
        setMenuIndexOnclick()
    });

    $w("#anchorFold4").onViewportEnter((event) => {
        menuCurrentIndex = 4
        setMenuIndexOnclick()
    });

    $w("#anchorFold5").onViewportEnter((event) => {
        menuCurrentIndex = 5
        setMenuIndexOnclick()
    });

    $w("#anchorFold6").onViewportEnter((event) => {
        menuCurrentIndex = 6
        setMenuIndexOnclick()
    });

    $w("#anchorFold7").onViewportEnter((event) => {
        menuCurrentIndex = 7
        setMenuIndexOnclick()
    });

    $w("#anchorFold8").onViewportEnter((event) => {
        menuCurrentIndex = 8
        setMenuIndexOnclick()
    });

    // cover color 

    function coverAllColorline() {
        $w("#boxCoverColor1").hide()
        $w("#boxCoverColor2").hide()
        $w("#boxCoverColor3").hide()
        $w("#boxCoverColor4").hide()
        $w("#boxCoverColor5").hide()
        $w("#boxCoverColor6").hide()
        $w("#boxCoverColor7").hide()
        $w("#boxCoverColor8").hide()
    }

    // click

    function setItemSelected1() {
        coverAllColorline()
        $w("#boxCoverColor1").show()

        $w("#boxMenu1").style.backgroundColor = "#9CDCEC"
        $w("#boxMenu1").style.borderColor = "#2F2F30"

        $w("#boxMenuDevide1").style.backgroundColor = "#2F2F30"

        $w("#textMenu1").html = `<p style="color: #2F2F30">${text1}</p>`
        $w("#textMenuNum1").html = `<p style="color: #2F2F30">1</p>`
    }

    function setItemSelected2() {
        coverAllColorline()
        $w("#boxCoverColor2").show()

        $w("#boxMenu2").style.backgroundColor = "#DAF2F8"
        $w("#boxMenu2").style.borderColor = "#2F2F30"
        // $w("#boxMenu1").style.borderColor = "#2F2F30"

        $w("#boxMenuDevide2").style.backgroundColor = "#2F2F30"

        $w("#textMenu2").html = `<p style="color: #2F2F30">${text2}</p>`
        $w("#textMenuNum2").html = `<p style="color: #2F2F30">2</p>`
    }

    function setItemSelected3() {
        coverAllColorline()
        $w("#boxCoverColor3").show()

        $w("#boxMenu3").style.backgroundColor = "#FFDF6A"
        $w("#boxMenu3").style.borderColor = "#2F2F30"
        // $w("#boxMenu2").style.borderColor = "#2F2F30"

        $w("#boxMenuDevide3").style.backgroundColor = "#2F2F30"

        $w("#textMenu3").html = `<p style="color: #2F2F30">${text3}</p>`
        $w("#textMenuNum3").html = `<p style="color: #2F2F30">3</p>`
    }

    function setItemSelected4() {
        coverAllColorline()
        $w("#boxCoverColor4").show()

        $w("#boxMenu4").style.backgroundColor = "#DBD7F9"
        $w("#boxMenu4").style.borderColor = "#2F2F30"
        // $w("#boxMenu3").style.borderColor = "#2F2F30"

        $w("#boxMenuDevide4").style.backgroundColor = "#2F2F30"

        $w("#textMenu4").html = `<p style="color: #2F2F30">${text4}</p>`
        $w("#textMenuNum4").html = `<p style="color: #2F2F30">4</p>`
    }

    function setItemSelected5() {
        coverAllColorline()
        $w("#boxCoverColor5").show()

        $w("#boxMenu5").style.backgroundColor = "#8267C1"
        $w("#boxMenu5").style.borderColor = "#2F2F30"
        // $w("#boxMenu4").style.borderColor = "#2F2F30"

        $w("#boxMenuDevide5").style.backgroundColor = "#2F2F30"

        $w("#textMenu5").html = `<p style="color: #fff">${text5}</p>`
        $w("#textMenuNum5").html = `<p style="color: #fff">5</p>`
    }

    function setItemSelected6() {
        coverAllColorline()
        $w("#boxCoverColor6").show()

        $w("#boxMenu6").style.backgroundColor = "#BDE8F2"
        $w("#boxMenu6").style.borderColor = "#2F2F30"
        // $w("#boxMenu5").style.borderColor = "#2F2F30"

        $w("#boxMenuDevide6").style.backgroundColor = "#2F2F30"

        $w("#textMenu6").html = `<p style="color: #2F2F30">${text6}</p>`
        $w("#textMenuNum6").html = `<p style="color: #2F2F30">6</p>`
    }

    function setItemSelected7() {
        coverAllColorline()
        $w("#boxCoverColor7").show()

        $w("#boxMenu7").style.backgroundColor = "#FFFFFF"
        $w("#boxMenu7").style.borderColor = "#2F2F30"
        // $w("#boxMenu6").style.borderColor = "#2F2F30"

        $w("#boxMenuDevide7").style.backgroundColor = "#2F2F30"

        $w("#textMenu7").html = `<p style="color: #2F2F30">${text7}</p>`
        $w("#textMenuNum7").html = `<p style="color: #2F2F30">7</p>`
    }

    function setItemSelected8() {
        coverAllColorline()
        $w("#boxCoverColor8").show()

        $w("#boxMenu8").style.backgroundColor = "#FFDF6A"
        $w("#boxMenu8").style.borderColor = "#2F2F30"
        // $w("#boxMenu7").style.borderColor = "#2F2F30"

        $w("#boxMenuDevide8").style.backgroundColor = "#2F2F30"

        $w("#textMenu8").html = `<p style="color: #2F2F30">${text8}</p>`
        $w("#textMenuNum8").html = `<p style="color: #2F2F30">8</p>`
    }

    // hover

    function setItemHover1() {
        if (menuCurrentIndex !== 1) {
            $w("#boxMenu1").style.backgroundColor = "#2F2F30"
            $w("#boxMenu1").style.borderColor = "#fff"

            $w("#boxMenuDevide1").style.backgroundColor = "#fff"

            $w("#textMenu1").html = `<p style="color: #9CDCEC">${text1}</p>`
            $w("#textMenuNum1").html = `<p style="color: #9CDCEC">1</p>`
        }

    }

    function setItemHover2() {
        if (menuCurrentIndex !== 2) {
            $w("#boxMenu2").style.backgroundColor = "#2F2F30"
            $w("#boxMenu2").style.borderColor = "#fff"

            $w("#boxMenuDevide2").style.backgroundColor = "#fff"

            $w("#textMenu2").html = `<p style="color: #B3E1ED">${text2}</p>`
            $w("#textMenuNum2").html = `<p style="color: #B3E1ED">2</p>`
        }

    }

    function setItemHover3() {
        if (menuCurrentIndex !== 3) {
            $w("#boxMenu3").style.backgroundColor = "#2F2F30"
            $w("#boxMenu3").style.borderColor = "#fff"
            // $w("#boxMenu2").style.borderColor = "#2F2F30"

            $w("#boxMenuDevide3").style.backgroundColor = "#fff"

            $w("#textMenu3").html = `<p style="color: #FFDF6A">${text3}</p>`
            $w("#textMenuNum3").html = `<p style="color: #FFDF6A">3</p>`
        }

    }

    function setItemHover4() {
        if (menuCurrentIndex !== 4) {
            $w("#boxMenu4").style.backgroundColor = "#2F2F30"
            $w("#boxMenu4").style.borderColor = "#fff"
            // $w("#boxMenu3").style.borderColor = "#2F2F30"

            $w("#boxMenuDevide4").style.backgroundColor = "#fff"

            $w("#textMenu4").html = `<p style="color: #BDB2E6">${text4}</p>`
            $w("#textMenuNum4").html = `<p style="color: #BDB2E6">4</p>`
        }

    }

    function setItemHover5() {
        if (menuCurrentIndex !== 5) {
            $w("#boxMenu5").style.backgroundColor = "#2F2F30"
            $w("#boxMenu5").style.borderColor = "#fff"
            // $w("#boxMenu4").style.borderColor = "#2F2F30"

            $w("#boxMenuDevide5").style.backgroundColor = "#fff"

            $w("#textMenu5").html = `<p style="color: #A08CD4">${text5}</p>`
            $w("#textMenuNum5").html = `<p style="color: #A08CD4">5</p>`
        }

    }

    function setItemHover6() {
        if (menuCurrentIndex !== 6) {
            $w("#boxMenu6").style.backgroundColor = "#2F2F30"
            $w("#boxMenu6").style.borderColor = "#fff"
            // $w("#boxMenu5").style.borderColor = "#2F2F30"

            $w("#boxMenuDevide6").style.backgroundColor = "#fff"

            $w("#textMenu6").html = `<p style="color: #B3E1ED">${text6}</p>`
            $w("#textMenuNum6").html = `<p style="color: #B3E1ED">6</p>`
        }

    }

    function setItemHover7() {
        if (menuCurrentIndex !== 7) {
            $w("#boxMenu7").style.backgroundColor = "#2F2F30"
            $w("#boxMenu7").style.borderColor = "#fff"
            // $w("#boxMenu6").style.borderColor = "#2F2F30"

            $w("#boxMenuDevide7").style.backgroundColor = "#fff"

            $w("#textMenu7").html = `<p style="color: #8B8B8B">${text7}</p>`
            $w("#textMenuNum7").html = `<p style="color: #8B8B8B">7</p>`
        }

    }

    function setItemHover8() {
        if (menuCurrentIndex !== 8) {
            $w("#boxMenu8").style.backgroundColor = "#2F2F30"
            $w("#boxMenu8").style.borderColor = "#fff"
            // $w("#boxMenu7").style.borderColor = "#2F2F30"

            $w("#boxMenuDevide8").style.backgroundColor = "#fff"

            $w("#textMenu8").html = `<p style="color: #FFDF6A">${text8}</p>`
            $w("#textMenuNum8").html = `<p style="color: #FFDF6A">8</p>`
        }

    }

    // set all reg

    function setAllButtonsReg() {

        if (menuCurrentIndex !== 1) {
            $w("#boxMenu1").style.backgroundColor = "#2F2F30"
            $w("#boxMenu1").style.borderColor = "#fff"

            $w("#boxMenuDevide1").style.backgroundColor = "#fff"

            $w("#textMenu1").html = `<p style="color: #fff">${text1}</p>`
            $w("#textMenuNum1").html = `<p style="color: #fff">1</p>`
            //
        }

        if (menuCurrentIndex !== 2) {
            $w("#boxMenu2").style.backgroundColor = "#2F2F30"
            $w("#boxMenu2").style.borderColor = "#fff"

            $w("#boxMenuDevide2").style.backgroundColor = "#fff"

            $w("#textMenu2").html = `<p style="color: #fff">${text2}</p>`
            $w("#textMenuNum2").html = `<p style="color: #fff">2</p>`
            //
        }

        if (menuCurrentIndex !== 3) {
            $w("#boxMenu3").style.backgroundColor = "#2F2F30"
            $w("#boxMenu3").style.borderColor = "#fff"

            $w("#boxMenuDevide3").style.backgroundColor = "#fff"

            $w("#textMenu3").html = `<p style="color: #fff">${text3}</p>`
            $w("#textMenuNum3").html = `<p style="color: #fff">3</p>`
            //
        }

        if (menuCurrentIndex !== 4) {
            $w("#boxMenu4").style.backgroundColor = "#2F2F30"
            $w("#boxMenu4").style.borderColor = "#fff"

            $w("#boxMenuDevide4").style.backgroundColor = "#fff"

            $w("#textMenu4").html = `<p style="color: #fff">${text4}</p>`
            $w("#textMenuNum4").html = `<p style="color: #fff">4</p>`
            //
        }

        if (menuCurrentIndex !== 5) {
            $w("#boxMenu5").style.backgroundColor = "#2F2F30"
            $w("#boxMenu5").style.borderColor = "#fff"

            $w("#boxMenuDevide5").style.backgroundColor = "#fff"

            $w("#textMenu5").html = `<p style="color: #fff">${text5}</p>`
            $w("#textMenuNum5").html = `<p style="color: #fff">5</p>`
            //
        }

        if (menuCurrentIndex !== 6) {
            $w("#boxMenu6").style.backgroundColor = "#2F2F30"
            $w("#boxMenu6").style.borderColor = "#fff"

            $w("#boxMenuDevide6").style.backgroundColor = "#fff"

            $w("#textMenu6").html = `<p style="color: #fff">${text6}</p>`
            $w("#textMenuNum6").html = `<p style="color: #fff">6</p>`
            //
        }

        if (menuCurrentIndex !== 7) {
            $w("#boxMenu7").style.backgroundColor = "#2F2F30"
            $w("#boxMenu7").style.borderColor = "#fff"

            $w("#boxMenuDevide7").style.backgroundColor = "#fff"

            $w("#textMenu7").html = `<p style="color: #fff">${text7}</p>`
            $w("#textMenuNum7").html = `<p style="color: #fff">7</p>`
            //
        }

        if (menuCurrentIndex !== 8) {
            $w("#boxMenu8").style.backgroundColor = "#2F2F30"
            $w("#boxMenu8").style.borderColor = "#fff"

            $w("#boxMenuDevide8").style.backgroundColor = "#fff"

            $w("#textMenu8").html = `<p style="color: #fff">${text8}</p>`
            $w("#textMenuNum8").html = `<p style="color: #fff">8</p>`
            //
        }

    }

    //

    function setMenuIndexOnclick() {
        setAllButtonsReg()

        if (menuCurrentIndex === 1) {
            setItemSelected1()
        }

        if (menuCurrentIndex === 2) {
            setItemSelected2()
        }

        if (menuCurrentIndex === 3) {
            setItemSelected3()
        }

        if (menuCurrentIndex === 4) {
            setItemSelected4()
        }

        if (menuCurrentIndex === 5) {
            setItemSelected5()
        }

        if (menuCurrentIndex === 6) {
            setItemSelected6()
        }

        if (menuCurrentIndex === 7) {
            setItemSelected7()
        }

        if (menuCurrentIndex === 8) {
            setItemSelected8()
        }

    }

    //

    $w("#buttonSideMenu1").onClick((event) => {
        // menuCurrentIndex = 1
        // setMenuIndexOnclick()
        $w("#sectionFold1").scrollTo()
    });

    $w("#buttonSideMenu2").onClick((event) => {
        // menuCurrentIndex = 2
        // setMenuIndexOnclick()
        $w("#anchorFold2").scrollTo()

    });

    $w("#buttonSideMenu3").onClick((event) => {
        // menuCurrentIndex = 3
        // setMenuIndexOnclick()
        $w("#sectionFold3").scrollTo()

    });

    $w("#buttonSideMenu4").onClick((event) => {
        // menuCurrentIndex = 4
        // setMenuIndexOnclick()
        $w("#sectionFold4").scrollTo()

    });

    $w("#buttonSideMenu5").onClick((event) => {
        // menuCurrentIndex = 5
        // setMenuIndexOnclick()
        $w("#sectionFold5").scrollTo()

    });

    $w("#buttonSideMenu6").onClick((event) => {
        // menuCurrentIndex = 6
        // setMenuIndexOnclick()
        $w("#sectionFold6").scrollTo()

    });

    $w("#buttonSideMenu7").onClick((event) => {
        // menuCurrentIndex = 7
        // setMenuIndexOnclick()
        $w("#sectionFold7").scrollTo()

    });

    $w("#buttonSideMenu8").onClick((event) => {
        // menuCurrentIndex = 8
        // setMenuIndexOnclick()
        $w("#sectionFold9").scrollTo()

    });

    // out

    $w("#boxMenu1").onMouseOut((event) => {
        setMenuIndexOnclick()

    });

    $w("#boxMenu2").onMouseOut((event) => {
        setMenuIndexOnclick()

    });

    $w("#boxMenu3").onMouseOut((event) => {
        setMenuIndexOnclick()

    });

    $w("#boxMenu4").onMouseOut((event) => {
        setMenuIndexOnclick()

    });

    $w("#boxMenu5").onMouseOut((event) => {
        setMenuIndexOnclick()

    });

    $w("#boxMenu6").onMouseOut((event) => {
        setMenuIndexOnclick()

    });

    $w("#boxMenu7").onMouseOut((event) => {
        setMenuIndexOnclick()

    });

    $w("#boxMenu8").onMouseOut((event) => {
        setMenuIndexOnclick()

    });

    // in

    $w("#boxMenu1").onMouseIn((event) => {
        setAllButtonsReg()
        setItemHover1()
    });

    $w("#boxMenu2").onMouseIn((event) => {
        setAllButtonsReg()
        setItemHover2()
    });

    $w("#boxMenu3").onMouseIn((event) => {
        setAllButtonsReg()
        setItemHover3()
    });

    $w("#boxMenu4").onMouseIn((event) => {
        setAllButtonsReg()
        setItemHover4()
    });

    $w("#boxMenu5").onMouseIn((event) => {
        setAllButtonsReg()
        setItemHover5()
    });

    $w("#boxMenu6").onMouseIn((event) => {
        setAllButtonsReg()
        setItemHover6()
    });

    $w("#boxMenu7").onMouseIn((event) => {
        setAllButtonsReg()
        setItemHover7()
    });

    $w("#boxMenu8").onMouseIn((event) => {
        setAllButtonsReg()
        setItemHover8()
    });

}

// dropdown revenue //

export function dropdownRevenue() {
    $w("#buttonOpenDropdownRevenue").onClick((event) => {
        setDropdown()
    });

    //

    // console.log($w("#imageRevenueMob").src)

    $w("#buttonRevenue1").onClick((event) => {
        setDropdown()
        $w("#buttonOpenDropdownRevenue").label = $w("#buttonRevenue1").label
        $w("#revenueGraph").src = "wix:vector://v1/0784b1_f39a4bd597984d4ca34c2460e6c38b1b.svg/glo.svg"

        $w("#imageRevenueMob").hide()
            .then(() => {
                $w("#imageRevenueMob").src = "wix:image://v1/0784b1_54f2dffe99184760a3aede341db0151a~mv2.png/_.png#originWidth=513&originHeight=583"
                $w("#imageRevenueMob").show()
            });
    });

    $w("#buttonRevenue2").onClick((event) => {
        setDropdown()
        $w("#buttonOpenDropdownRevenue").label = $w("#buttonRevenue2").label
        $w("#revenueGraph").src = "wix:vector://v1/0784b1_377e2ef3cfd24882921a66fa39a1cb83.svg/us.svg"

        $w("#imageRevenueMob").hide()
            .then(() => {
                $w("#imageRevenueMob").src = "wix:image://v1/0784b1_f4a8183b44004c17a5771a0c245ca578~mv2.png/_.png#originWidth=513&originHeight=583"
                $w("#imageRevenueMob").show()
            });

    });

    $w("#buttonRevenue3").onClick((event) => {
        setDropdown()
        $w("#buttonOpenDropdownRevenue").label = $w("#buttonRevenue3").label
        $w("#revenueGraph").src = "wix:vector://v1/0784b1_568d333aed0045a49ecc724099c6bf0b.svg/uk.svg"

        $w("#imageRevenueMob").hide()
            .then(() => {
                $w("#imageRevenueMob").src = "wix:image://v1/0784b1_58ecbc261f724e3d80945c55f2b97589~mv2.png/_.png#originWidth=513&originHeight=583"
                $w("#imageRevenueMob").show()
            });

    });

    $w("#buttonRevenue4").onClick((event) => {
        setDropdown()
        $w("#buttonOpenDropdownRevenue").label = $w("#buttonRevenue4").label
        $w("#revenueGraph").src = "wix:vector://v1/0784b1_2746d373130246148ce628048bf6f79d.svg/fra.svg"

        $w("#imageRevenueMob").hide()
            .then(() => {
                $w("#imageRevenueMob").src = "wix:image://v1/0784b1_da92c192ed0841528f7b78ab094ee637~mv2.png/_.png#originWidth=513&originHeight=583"
                $w("#imageRevenueMob").show()
            });

    });

    $w("#buttonRevenue5").onClick((event) => {
        setDropdown()
        $w("#buttonOpenDropdownRevenue").label = $w("#buttonRevenue5").label
        $w("#revenueGraph").src = "wix:vector://v1/0784b1_85fa2f815faa486f818f302a933b3659.svg/bra.svg"

        $w("#imageRevenueMob").hide()
            .then(() => {
                $w("#imageRevenueMob").src = "wix:image://v1/0784b1_303178de6efb4d80ba3e1fc0fa545681~mv2.png/_.png#originWidth=513&originHeight=583"
                $w("#imageRevenueMob").show()
            });

    });

    $w("#buttonRevenue6").onClick((event) => {
        setDropdown()
        $w("#buttonOpenDropdownRevenue").label = $w("#buttonRevenue6").label
        $w("#revenueGraph").src = "wix:vector://v1/0784b1_f3acb6286e0c4c47befcc7cf422b9710.svg/mex.svg"

        $w("#imageRevenueMob").hide()
            .then(() => {
                $w("#imageRevenueMob").src = "wix:image://v1/0784b1_fcba3230dc2a454a816abf9bd0cd5be5~mv2.png/_.png#originWidth=513&originHeight=583"
                $w("#imageRevenueMob").show()
            });

    });

    $w("#buttonRevenue7").onClick((event) => {
        setDropdown()
        $w("#buttonOpenDropdownRevenue").label = $w("#buttonRevenue7").label
        $w("#revenueGraph").src = "wix:vector://v1/0784b1_6f86fca0a24a4ed899c842660b59800b.svg/jap.svg"

        $w("#imageRevenueMob").hide()
            .then(() => {
                $w("#imageRevenueMob").src = "wix:image://v1/0784b1_29e5c931872b4a46bd09cdb69b2a3262~mv2.png/_.png#originWidth=513&originHeight=583"
                $w("#imageRevenueMob").show()
            });

    });

    //

    function setDropdown() {
        if ($w("#boxRevenueOpen").collapsed) {
            $w("#boxRevenueOpen").expand()
            $w("#iconRevenueOpen").show()
            $w("#iconRevenueClose").hide()
        } else {
            $w("#boxRevenueOpen").collapse()
            $w("#iconRevenueOpen").hide()
            $w("#iconRevenueClose").show()
        }

    }
}

// dropdown graph //

let textItems

export function monthsDropDownEvents() {

    // console.log($w("#imageGraphSales").src)

    wixData.query("texttopsalesmonths")
        .ascending("monthOrder")
        .find()
        .then((results) => {
            textItems = results.items;
            console.log(textItems)
            // 

        })
        .catch((err) => {
            let errorMsg = err;
        });

    //

    const months = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov'];

    $w("#buttonOpenDropdownGraph").onClick((event) => {
        setmonthsDropdown()
    });
    months.forEach(month => {
        $w(`#${month}Btn`).onClick(() => {
            setmonthsDropdown()
            $w("#buttonOpenDropdownGraph").label = $w(`#${month}Btn`).label;
            sendDataToChart();

            function hideAllmonths() {
                $w("#imageGraph1").hide()
                $w("#imageGraph2").hide()
                $w("#imageGraph3").hide()
                $w("#imageGraph4").hide()
                $w("#imageGraph5").hide()
                $w("#imageGraph6").hide()
                $w("#imageGraph7").hide()
                $w("#imageGraph8").hide()
                $w("#imageGraph9").hide()
                $w("#imageGraph10").hide()
                $w("#imageGraph11").hide()

            }

            if (month === 'Jan') {
                $w("#textTopSales").text = textItems[0].monthText

                hideAllmonths()
                $w("#imageGraph1").show()

            }

            if (month === 'Feb') {
                $w("#textTopSales").text = textItems[1].monthText

                hideAllmonths()
                $w("#imageGraph2").show()

            }

            if (month === 'March') {
                $w("#textTopSales").text = textItems[2].monthText

                hideAllmonths()
                $w("#imageGraph3").show()

            }

            if (month === 'April') {
                $w("#textTopSales").text = textItems[3].monthText

                hideAllmonths()
                $w("#imageGraph4").show()

            }

            if (month === 'May') {
                $w("#textTopSales").text = textItems[4].monthText

                hideAllmonths()
                $w("#imageGraph5").show()

            }

            if (month === 'June') {
                $w("#textTopSales").text = textItems[5].monthText

                hideAllmonths()
                $w("#imageGraph6").show()

            }

            if (month === 'July') {
                $w("#textTopSales").text = textItems[6].monthText

                hideAllmonths()
                $w("#imageGraph7").show()

            }

            if (month === 'Aug') {
                $w("#textTopSales").text = textItems[7].monthText

                hideAllmonths()
                $w("#imageGraph8").show()

            }

            if (month === 'Sep') {
                $w("#textTopSales").text = textItems[8].monthText

                hideAllmonths()
                $w("#imageGraph9").show()

            }

            if (month === 'Oct') {
                $w("#textTopSales").text = textItems[9].monthText

                hideAllmonths()
                $w("#imageGraph10").show()

            }

            if (month === 'Nov') {
                $w("#textTopSales").text = textItems[10].monthText

                hideAllmonths()
                $w("#imageGraph11").show()

            }
        })
    })
}

function setmonthsDropdown() {
    if ($w("#boxGraphOpen").collapsed) {
        $w("#boxGraphOpen").expand()
        $w("#iconGraphOpen").show()
        $w("#iconGraphClose").hide()
    } else {
        $w("#boxGraphOpen").collapse()
        $w("#iconGraphOpen").hide()
        $w("#iconGraphClose").show()
    }
}

export function shareBtn() {

    let checkIfHoverShare = false

    console.log($w("#textShare").html)

    hoverSetup()

    function hoverSetup() {

        $w("#buttonShare").onMouseIn((event) => {
            if (!checkIfHoverShare) {
                $w("#iconShareBlue").show()
                $w("#iconShareWhite").hide()

                $w("#textShare").html = `<p style="color: #9CDCEC; font-weight: bold">SHARE<br />THIS<br />PAGE</p>`
            }

        });

        $w("#buttonShare").onMouseOut((event) => {
            if (!checkIfHoverShare) {
                $w("#iconShareBlue").hide()
                $w("#iconShareWhite").show()

            }

            $w("#textShare").html = `<p style="color: #fff; font-weight: bold">SHARE<br />THIS<br />PAGE</p>`

        });
    }

    $w("#buttonShare").onClick((event) => {

        checkIfHoverShare = true
        hoverSetup()

        wixWindow.copyToClipboard("https://www.wix.com/ecommerce/end-of-year-report")
            .then(() => {
                // handle case where text was copied
                $w("#textShare").hide()
                $w("#iconShareWhite").hide()
                $w("#iconShareBlue").hide()
                $w("#textCopied").show()
                $w("#boxShareBg").style.backgroundColor = "#00495C"

                setTimeout(function () {
                    checkIfHoverShare = false
                    $w("#textShare").html = `<p style="color: #fff; font-weight: bold">SHARE<br />THIS<br />PAGE</p>`

                    $w("#textShare").show()
                    $w("#iconShareWhite").show()
                    $w("#iconShareBlue").hide()
                    $w("#textCopied").hide()
                                    $w("#boxShareBg").style.backgroundColor = "#2F2F30"

                }, 2200);
            })
            .catch((err) => {
                // handle case where an error occurred
            });
    });
}